import type { CSSProperties, JSX } from 'react';
import pageNotFoundSvg from '../assets/images/error/404-not-found.svg';

/**
 * Decorative "page not found" illustration. Loaded via <img> (not inlined as
 * JSX) since its colors are literal hex, not `currentColor`/CSS custom
 * properties — nothing here needs the host page's styles to resolve.
 */
export function PageNotFoundIllustration({
  className,
  style,
}: {
  readonly className?: string;
  readonly style?: CSSProperties;
}): JSX.Element {
  return <img alt="" aria-hidden="true" className={className} src={pageNotFoundSvg} style={style} />;
}
